import { Component, Injectable, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbDateStruct, NgbCalendar, NgbCalendarIslamicUmalqura, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import * as momentHijri from 'moment-hijri';
const WEEKDAYS = ['ح', 'ن', 'ث', 'ر', 'خ', 'ج', 'س'];
const MONTHS = [
  'محرم',
  'صفر',
  'ربيع الأول',
  'ربيع الآخر',
  'جمادى الأولى',
  'جمادى الآخرة',
  'رجب',
  'شعبان',
  'رمضان',
  'شوال',
  'ذو القعدة',
  'ذو الحجة',
];

@Injectable()
export class IslamicI18n extends NgbDatepickerI18n {
  getWeekdayShortName(weekday: number) {
    return WEEKDAYS[weekday - 1];
  }

  getMonthShortName(month: number) {
    return MONTHS[month - 1];
  }

  getMonthFullName(month: number) {
    return MONTHS[month - 1];
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.day}/${date.month}/${date.year}`;
  }
}
@Component({
  selector: 'hijri-date-picker',
  templateUrl: './hijri-date-picker.component.html',
  styleUrls: ['./hijri-date-picker.component.scss'],
  providers: [
    { provide: NgbCalendar, useClass: NgbCalendarIslamicUmalqura },
    { provide: NgbDatepickerI18n, useClass: IslamicI18n },
  ],
})
export class HijriDatePickerComponent implements OnInit {
  model: NgbDateStruct = {} as NgbDateStruct;
  @Input() set date(value: string) {
    this._date = value;
  }
  get date(): string {
    return this._date;
  }
  _date: string = null;
  private hijriDate: any;
  @Input() disable: boolean = false;
  @Output() dateChange: EventEmitter<string> = new EventEmitter<string>();
  constructor(private calendar: NgbCalendar) {
    momentHijri.locale('en-US');
  }

  selectToday() {
    this.model = this.calendar.getToday();
  }

  ngOnInit() {
    if (this.date) {
      this.hijriDate = momentHijri(this.date, 'YYYY-MM-DDTHH:mm:ss');
    } else {
      this.hijriDate = momentHijri(new Date());
    }
    this.model.day = this.hijriDate.iDate();
    this.model.month = this.hijriDate.iMonth() + 1;
    this.model.year = this.hijriDate.iYear();
  }
  onDateChange() {
    this.date = momentHijri(`${this.model.year}/${this.model.month}/${this.model.day}`, 'iYYYY/iM/iD').format(
      'YYYY-MM-DDTHH:mm:ss',
    );
    this.dateChange.emit(this.date);
    // console.log(this.date);
  }

  changeDateToHijri() {}
  changeDateToGregorian() {}
}
